module.exports = __webpack_public_path__ + "img/activity21.e90e65fb.png";